<template>
  <div>
    <div class="big-screen-loading">
      <div class="loading-inner">
        <img
          class="loading-img"
          :src="require('@assets/bigscreen/loading.png')"
        />
      </div>
      <div class="loading-text">加载中...</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BigScreenLoading",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.big-screen-loading {
  position: relative;
  font-size: 0;
  text-align: center;
  color: white;
  width: 20.74vh;
  height: 15vh;
  background: rgba(68, 68, 68, 0.5);
  border-radius: 0.8333vh;
  margin: 0 auto;
  .loading-inner {
    position: absolute;
    top: 4.444vh;
    left: 0;
    right: 0;
    .loading-img {
      width: 2.777vh;
      height: 2.777vh;
      display: inline-block;
      animation: bigScreenLoading 1s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
    }
  }
  .loading-text {
    padding-top: 9.074vh;
    font-size: 1.851vh;
  }
}
@keyframes bigScreenLoading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
